<app-dialog [title]=" 'term.settings' | translate">

  <ng-container appDialogContent>

    @if (!isAdminPortal) {
      <mat-form-field>
        <mat-label>{{ 'term.state-update-frequency' | translate }}</mat-label>

        <input matInput
          type="number"
          min="10"
          [formControl]="updateFrequency">

          @if (updateFrequency.touched && updateFrequency.hasError('required')) {
            <mat-error> {{ 'message.error.required-field' | translate }}</mat-error>
          }

          @if (updateFrequency.touched && updateFrequency.hasError('min')) {
            <mat-error> {{ 'message.error.min-value' | translate:{min: updateFrequency.errors?.['min'].min} }}</mat-error>
          }

        </mat-form-field>
      }

      <cmn-select-language [label]="'term.language-interface' | translate"
        [appearance]="'outline'"
        [language]="changeTracker.interfaceLanguage"
        (languageChange)="onInterfaceLanguageChange($event)">
      </cmn-select-language>

      @if (!isAdminPortal) {
        <cmn-select-language
          [label]="'term.language-address' | translate"
          [disabled]="isDisabled"
          [appearance]="'outline'"
          [language]="changeTracker.addressLanguage"
          (languageChange)="onAddressLanguageChange($event)">
        </cmn-select-language>
      }

      <app-select-timezone [timezone]="changeTracker.timezone"
        [disabled]="isDisabled"
        (timezoneChange)="onTimezoneChange($event)">
      </app-select-timezone>
    </ng-container>

    <ng-container appDialogActions>
      <app-dialog-actions-cancel-save [showSpinner]="showSpinner"
        [saveDisable]="!changeTracker.hasChanges || showSpinner || (updateFrequency && updateFrequency.invalid)"
        (save)="onSubmit()"
        (cancel)="closeDialog()">
      </app-dialog-actions-cancel-save>
    </ng-container>

  </app-dialog>
